import { action } from '@ember/object';
import Controller from '@ember/controller';

export default class ErrorController extends Controller {
  @action
  goBack() {
    window.history.back();
  }
}
